export default {
  LOAD_STUDY_PLAN_FORM_PAGE_START: 'LoadStudyPlanFormPageStart',
  LOAD_STUDY_PLAN_FORM_PAGE_END: 'LoadStudyPlanFormPageEnd',
  LOAD_STUDY_PLAN_FORM_PAGE_STUDY_PROGRAMS_START: 'LoadStudyPlanFormPageStudyProgramsStart',
  LOAD_STUDY_PLAN_FORM_PAGE_STUDY_PROGRAMS_END: 'LoadStudyPlanFormPageStudyProgramsEnd'
};